// extracted by mini-css-extract-plugin
export default {"wrapper":"Mailings_wrapper__yKID8","content":"Mailings_content__ny4UP"};